// extracted by mini-css-extract-plugin
export default {"button-area":"ButtonArea_button-area__OIOXu","button":"ButtonArea_button__VKA9B"};